import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const serviceLinks = [
    { label: 'Heating Services', path: '/heating' },
    { label: 'Air Conditioning', path: '/air-conditioning' },
    { label: 'Heat Pumps', path: '/heat-pumps' },
    { label: 'Plumbing Services', path: '/plumbing' },
    { label: 'Electrical Services', path: '/electrical' },
    { label: 'Water Heaters', path: '/water-heaters' },
    { label: 'Insulation', path: '/insulation' },
    { label: 'Indoor Air Quality', path: '/air-quality' },
  ];

  const planLinks = [
    { label: 'Maintenance Plans', path: '/maintenance-plans' },
    { label: 'Financing Options', path: '/financing' },
    { label: 'Rebates & Incentives', path: '/rebates-incentives' },
    { label: 'Commercial Services', path: '/commercial' },
    { label: 'Service Areas', path: '/service-areas' },
  ];

  const companyLinks = [
    { label: 'About Renova', path: '/about' },
    { label: 'Careers', path: '/careers' },
    { label: 'Acquisition & Partnerships', path: '/about' },
    { label: 'Contact Us', path: '/contact' },
    { label: 'Book Appointment', path: '/book-appointment' },
  ];

  const seoLinks = [
    { label: 'Furnace Installation', path: '/furnace-installation' },
    { label: 'AC Installation', path: '/ac-installation' },
    { label: 'Heat Pump Installation', path: '/heat-pump-installation' },
    { label: 'Water Heater Install', path: '/water-heater-installation' },
    { label: 'Emergency HVAC', path: '/emergency-hvac' },
    { label: 'HVAC Maintenance', path: '/hvac-maintenance' },
    { label: 'Ductless Systems', path: '/ductless-systems' },
    { label: 'Tankless Water Heaters', path: '/tankless-water-heaters' },
  ];

  return (
    <footer className="bg-[#0C2340] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 mb-10">
          <div className="lg:col-span-1">
            <div className="mb-4">
              <button onClick={() => navigate('/')} className="cursor-pointer">
                <img
                  src="https://storage.readdy-site.link/project_files/6746c619-ced5-4466-9905-8e7d3536934a/5532c650-c920-4128-a9ff-6bc5d55a55b5_Renova-Comfort-Logo-transparent.png?v=83a557bfc10fb655cb318d63a2085589"
                  alt="Renova Comfort"
                  className="h-36 w-auto object-contain brightness-0 invert"
                />
              </button>
            </div>
            <p className="text-sm text-white/60 mb-5 leading-relaxed">
              Full-service home comfort and energy solutions. HVAC, plumbing, electrical, and energy efficiency upgrades. One company, total care.
            </p>
            <div className="space-y-2">
              <a href="tel:+18506698335" className="flex items-center space-x-2 text-sm font-semibold text-white hover:text-[#C41E3A] transition-colors">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-[#C41E3A]" />
                </div>
                <span>(850) 669-8335</span>
              </a>
              <a href="mailto:hello@renovacomfort.com" className="flex items-center space-x-2 text-sm text-white/60 hover:text-white transition-colors">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-white/40" />
                </div>
                <span>hello@renovacomfort.com</span>
              </a>
              <div className="flex items-start space-x-2 text-sm text-white/60">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-white/40" />
                </div>
                <span>7901 4th St N # 33139<br />St. Petersburg, FL 33702</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Services</h4>
            <ul className="space-y-2">
              {serviceLinks.map((l) => (
                <li key={l.path}>
                  <button onClick={() => navigate(l.path)} className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer whitespace-nowrap text-left">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Plans & More</h4>
            <ul className="space-y-2">
              {planLinks.map((l) => (
                <li key={l.path}>
                  <button onClick={() => navigate(l.path)} className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer whitespace-nowrap text-left">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Company</h4>
            <ul className="space-y-2">
              {companyLinks.map((l) => (
                <li key={l.path}>
                  <button onClick={() => navigate(l.path)} className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer whitespace-nowrap text-left">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Resources</h4>
            <ul className="space-y-2">
              {seoLinks.map((l) => (
                <li key={l.path}>
                  <button onClick={() => navigate(l.path)} className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer whitespace-nowrap text-left">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="grid md:grid-cols-2 gap-6 items-start">
            <div className="space-y-1">
              <div className="flex flex-wrap gap-4 text-xs text-white/40">
                <span>© 2025 Renova Comfort, LLC. All Rights Reserved.</span>
                <button onClick={() => {}} className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Privacy Policy</button>
                <button onClick={() => {}} className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Terms of Service</button>
              </div>
              <p className="text-xs text-white/30">Licensed &amp; Insured &nbsp;·&nbsp; Heating, Air Conditioning, Plumbing, Electrical &nbsp;·&nbsp; Florida License # (future)</p>
            </div>
            <div className="flex items-center space-x-4 md:justify-end">
              {[
                { icon: 'ri-facebook-fill', href: 'https://facebook.com' },
                { icon: 'ri-twitter-x-line', href: 'https://twitter.com' },
                { icon: 'ri-instagram-line', href: 'https://instagram.com' },
                { icon: 'ri-linkedin-fill', href: 'https://linkedin.com' },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 bg-white/10 rounded-lg flex items-center justify-center text-white/60 hover:bg-[#1A56A0] hover:text-white transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
